export const ADD_TICKET = "ticketBooking/add_ticket";
export const DELETE_TICKET = "ticketBooking/delete_ticket";
